export enum Permissions {
	CUSTOMERS_READ = 'CUSTOMERS_READ',
	CUSTOMERS_EDIT = 'CUSTOMERS_EDIT',
	USERS_READ = 'USERS_READ',
	USERS_EDIT = 'USERS_EDIT',
	CONTRACTS_READ = 'CONTRACTS_READ',
	CONTRACTS_EDIT = 'CONTRACTS_EDIT',
	SERVICES_READ = 'SERVICES_READ',
	SERVICES_EDIT = 'SERVICES_EDIT',
	INVOICES_READ = 'INVOICES_READ',
	INVOICES_EDIT = 'INVOICES_EDIT',
	PAYMENTS_READ = 'PAYMENTS_READ',
	PAYMENTS_EDIT = 'PAYMENTS_EDIT',
	REPORTS_READ = 'REPORTS_READ',
	TENANT_READ = 'TENANT_READ',
	TENANT_WRITE = 'TENANT_WRITE',
	SETTINGS_READ = 'SETTINGS_READ',
	SETTINGS_EDIT = 'SETTINGS_EDIT',
	FILES_UPLOAD = 'UPLOAD_FILES',
	FILES_DOWNLOAD = 'UPLOAD_FILES',
	ROLES_READ = 'ROLES_READ',
	ROLES_EDIT = 'ROLES_EDIT',
	ALLOWED_TO_LOGGED_USER = 'ALLOWED_TO_LOGGED_USER',
	DOCUMENTS_READ = 'DOCUMENTS_READ',
	DOCUMENTS_EDIT = 'DOCUMENTS_EDIT',
	DOCUMENTS_STRUCTURE = 'DOCUMENTS_STRUCTURE',
	NOTIFICATION_READ = 'NOTIFICATION_READ',
	NOTIFICATION_EDIT = 'NOTIFICATION_EDIT',
	COMPANY_STRUCTURE_READ = 'COMPANY_STRUCTURE_READ',
	COMPANY_STRUCTURE_EDIT = 'COMPANY_STRUCTURE_EDIT',
}
